import { COLORS } from 'app/constants'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text } from 'styles/reactnative'
import { useExchangeList } from '../../hooks/trade/exchangeList'

const PnlPrice = ({
	ep_id = undefined,
	price = 0,
	rate = false,
	style = {},
	dp = undefined,
	krw = false,
	usdt = false,
	plus = true,
}: any) => {
	const { data: EPs } = useExchangeList()
	const EP = EPs?.find(ep => ep?.id === ep_id)

	return (
		<Text
			style={{
				justifyContent: 'flex-end',
				whiteSpace: 'nowrap',
				fontSize:12,
				color:
					price > 0
						? COLORS.lightGreen
						: price === 0
						? 'black'
						: COLORS.lightRed,

				...style,
			}}>
			{plus && price > 0 ? '+' : ''}
			{BigNumber(price).toFormat(dp >= 0 ? dp : dp || EP?.dp || 3)}
			{krw && '원'}
			{usdt && '$'}
			{rate && '%'}
		</Text>
	)
}

export default React.memo(PnlPrice)
